import React from 'react';
import {tapyblAiHomeText} from './tapyblAiHomeText';
import './styles.css';
import {Link} from 'react-router-dom';
import PageTitle from '../../../uiToolkit/PageTitle';
import {Tour} from '../../../modules/Tour';

interface Props {
  username?: string;
}

const TapyblAIHome = React.memo(({username}: Props) => {
  return (
    <div className="TapyblAiHomeContainer">
      <PageTitle
        title={`${tapyblAiHomeText.title}, ${username ?? ''}`}
        subtitle={tapyblAiHomeText.subtitle}
      />

      <Tour section="aiHome" />

      <div className="InfoSection">
        <h1 className="Heading">{tapyblAiHomeText.selection}</h1>
        <div className="Options">
          <Link to="generate_microlesson" className="PathCard microLessonsCard">
            <span className="icon-ai_assistant_ic" />
            <h1 className="PathTitle">{tapyblAiHomeText.microlessons}</h1>
            <p>{tapyblAiHomeText.microlesosnsDescription}</p>
          </Link>
          <Link to="ai_assistant" className="PathCard aiAssistantsCard">
            <span className="icon-ai_assistant_ic" />
            <h1 className="PathTitle">{tapyblAiHomeText.aiAssistants}</h1>
            <p>{tapyblAiHomeText.aiAssistantsDescription}</p>
          </Link>
          <Link to="generate_video" className="PathCard  videosCard">
            <span className="icon-ai_video_icon" />
            <h1 className="PathTitle">{tapyblAiHomeText.videos}</h1>
            <p>{tapyblAiHomeText.aiVideosDescription}</p>
          </Link>
          <Link to="../courses/create" className="PathCard  coursesCard">
            <span className="icon-courses_ic" />
            <h1 className="PathTitle">{tapyblAiHomeText.courses}</h1>
            <p>{tapyblAiHomeText.coursesDescription}</p>
          </Link>
        </div>
      </div>
    </div>
  );
});

export default TapyblAIHome;
